import React from 'react';
import Select from 'react-select';

const indicatorSeparatorStyle = {
  alignSelf: 'stretch',
  backgroundColor: '#5243AA',
  marginBottom: 8,
  marginTop: 8,
  width: 1,
};

const IndicatorSeparator = ({ innerProps }) => {
  return <span style={indicatorSeparatorStyle} {...innerProps} />;
};

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    borderColor: state.isFocused ? 'black' : provided.borderColor,
    boxShadow: state.isFocused ? '0 0 0 1px black' : 'none',
    '&:hover': {
      borderColor: 'black',
    },
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 999999999999,
  }),
};

const MultiSelectDropdown = ({
  data,
  handleChange,
  selectedValue,
  labelKey = 'label',
  valueKey = 'value',
  placeholder = 'Select...',
  isLoading = false,
}) => {
  const options = data?.map((item) => ({
    value: item[valueKey],
    label: item[labelKey],
  }));

  return (
    <Select
      closeMenuOnSelect={false}
      components={{ IndicatorSeparator }}
      isMulti
      options={options}
      styles={customStyles}
      onChange={handleChange}
      value={selectedValue}
      placeholder={placeholder}
      isLoading={isLoading}
    />
  );
};

export default MultiSelectDropdown;
